module.exports = __webpack_public_path__ + "img/adam_bot.75632d3b.jpg";